angular.module('cpm').constant('CREATIVE_SOURCES', {
    REFLOW: 0,
    ADOBE_EDGE: 1,
    GOOGLE_WEB_DESIGNER: 2,
    CUSTOM_HTML: 3,
    TEMPLATE: 4,
    REFLOW_STUB: 5,
    CAMPAIGN_MANAGER: 6
});
